// cbTrackData=window.cbTrackData || {}; 
// cbTrackData.pageCode = '404errorpage';
(function(kiwi, _satellite){
    var applicationDataLayer = {
        page: {
            errorCode: '404'               //example, options: 404, 500, down, highvolume, 403
        }
    };
    try {kiwi.mergeDdl(applicationDataLayer);}
    catch(err) {if(typeof _satellite !== 'undefined') _satellite.logger.error('Something went wrong with kiwi.mergeDdl(): '+ err.message);}
})(window.kiwi, window._satellite);